// Creates an object URL for a blob, triggers a browser download via a transient
// anchor tag, then revokes the URL. An existing copy of this dance lives in
// UploadCard/utils/api/helpers.ts (downloadFile) — left as-is (out of scope); this
// is the single implementation for new callers, and that can migrate later.
export function downloadBlobFromUrl(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
